
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Conclusion = () => {
  return (
    <>
      <p className="text-lg text-[#212529] leading-relaxed">
        Premium Strategies have been selected carefully and only the best trading strategies are made available for users. Premium strategies are reliable, transparent, and professionally managed. They are made available based on past performance, risk management, provider reputation, and exchange security. By working with experienced and ethical providers, Premium Strategies ensure an optimal trading experience for all users.
      </p>
      <div className="mt-8 flex justify-center">
        <Link to="/pricing">
          <Button className="bg-corporate-secondary-100 hover:bg-corporate-secondary-75 text-corporate-primary-100 px-6 py-2 text-lg font-medium rounded-lg">
            Explore Premium Plans
          </Button>
        </Link>
      </div>
    </>
  );
};

export default Conclusion;
